import { z } from 'zod';
export const persistentAgentOperationDefaultMaxWorkers = 10;
export const persistentAgentOperationHardMaxWorkers = 50;
export const persistentAgentOperationStateLaneId = 'operation_state';
export const persistentAgentWorkerAssignmentLaneId = 'worker_assignment';
export const persistentAgentOperationProjectionLaneIds = [
    persistentAgentOperationStateLaneId,
    persistentAgentWorkerAssignmentLaneId,
];
export function isPersistentAgentOperationProjectionLane(laneId) {
    return persistentAgentOperationProjectionLaneIds.includes(laneId);
}
export const PersistentAgentOperationStatusSchema = z.enum([
    'ACTIVE',
    'PAUSED',
    'STOPPED',
    'COMPLETED',
    'FAILED',
]);
export const PersistentAgentOperationWorkerStatusSchema = z.enum([
    'STARTING',
    'IDLE',
    'WORKING',
    'BLOCKED',
    'STOPPED',
    'FAILED',
]);
export const PersistentAgentOperationResourceSchema = z.object({
    key: z.string().min(1).max(500),
    data: z.unknown().optional(),
    active: z.boolean().default(true),
});
export const PersistentAgentOperationWorkerSchema = z.object({
    id: z.string(),
    operationId: z.string(),
    persistentAgentId: z.string(),
    scope: z.string(),
    status: PersistentAgentOperationWorkerStatusSchema,
    lastActivityAt: z.coerce.date().nullable(),
    lastTool: z.string().nullable(),
    failure: z.unknown().nullable(),
    createdAt: z.coerce.date(),
    updatedAt: z.coerce.date(),
    retiredAt: z.coerce.date().nullable(),
});
export const PersistentAgentOperationSchema = z.object({
    id: z.string(),
    supervisorAgentId: z.string(),
    objective: z.string(),
    strategy: z.string().nullable(),
    resources: z.array(PersistentAgentOperationResourceSchema),
    status: PersistentAgentOperationStatusSchema,
    revision: z.number().int().nonnegative(),
    maxWorkers: z.number().int().positive(),
    startedAt: z.coerce.date(),
    pausedAt: z.coerce.date().nullable(),
    stoppedAt: z.coerce.date().nullable(),
    createdAt: z.coerce.date(),
    updatedAt: z.coerce.date(),
});
export const StartPersistentAgentOperationInputSchema = z.object({
    objective: z.string().min(1).max(50_000),
    strategy: z.string().max(20_000).optional(),
    maxWorkers: z.number().int().min(1).max(persistentAgentOperationHardMaxWorkers).optional(),
});
export const UpsertPersistentAgentOperationResourcesInputSchema = z.object({
    operationId: z.string(),
    expectedRevision: z.number().int().nonnegative(),
    resources: z.array(PersistentAgentOperationResourceSchema).min(1).max(1000),
});
export const PersistentAgentOperationStateProjectionSchema = z.object({
    operation: PersistentAgentOperationSchema,
    workers: z.array(PersistentAgentOperationWorkerSchema),
    coordinationGuidance: z
        .object({
        urgency: z.string(),
        workerLifecycle: z.string(),
        messaging: z.string(),
    })
        .optional(),
    recentExceptions: z.array(z.unknown()).max(50),
    scorecard: z.unknown().optional(),
});
export const PersistentAgentWorkerAssignmentProjectionSchema = z.object({
    operationId: z.string(),
    revision: z.number().int().nonnegative(),
    supervisorAgentId: z.string(),
    operationStatus: PersistentAgentOperationStatusSchema,
    objective: z.string(),
    strategy: z.string().nullable(),
    resources: z.array(PersistentAgentOperationResourceSchema),
    worker: PersistentAgentOperationWorkerSchema,
    guidance: z.string().optional(),
    recentFailures: z.array(z.unknown()).max(20),
});
//# sourceMappingURL=persistent-agent-operation.js.map